/**
 * Theme-wide campaign order tagging.
 *
 * Ensures every cart carries a `_campaign` attribute, which the
 * "Assign campaign tag to order" Shopify Flow turns into an order tag
 * ("Campaign: <value>").
 *
 * Only fills the attribute when it is EMPTY: page-specific tags written by
 * the buy-buttons hidden input (order_tag block setting) or analytics.js
 * (?campaign= URL param) fire at add-to-cart time and take precedence —
 * this script never overwrites an existing value.
 *
 * Known gap: dynamic checkout buttons (Buy it now / Shop Pay / PayPal)
 * skip the cart entirely, so those orders cannot be tagged from the theme.
 */
(function () {
  var config = window.CampaignTagSync;
  if (!config || !config.campaign) return;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  fetch(root + 'cart.js')
    .then(function (response) {
      return response.json();
    })
    .then(function (cart) {
      if (cart && cart.attributes && cart.attributes._campaign) return;

      return fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { _campaign: config.campaign } }),
      });
    })
    .catch(function () {
      /* Tagging is best-effort — never break the storefront over it. */
    });
})();
